define('components/factory/models/MultiProductsModel', [

], function() {

    var MultiProductsModel = Backbone.Model.extend({
        defaults: {
            viewId: "multiproducts-id",                 // Classic default viewId
            products: [],                               // Array of all products
            suffixClass: "multi",                       // Default class to add ("multi" || "grid")
            currencySymbol: null,                       // Correlation array
            title: null,                                // Title of the view. If empty -> hidden
            allowMultipleBuy: true,                     // Hide show price details & checkboxes
            formatHelper: null,                         // Give a currency format helper if needed
            autoselectHiddenProducts: false,            // Select hidden products or not
            onAddToCartCallback: function() {},         // Callback on click js-maz-multiproduct-order-btn button
            isReady: false                              // Classic isReady
        }
    });

    return MultiProductsModel;
});
